import React, { useState } from 'react';
import { MdIosShare, MdSettings } from 'react-icons/md';
import { IoMdBarcode } from 'react-icons/io';
import { useRouter } from 'next/router';
import { RiMessage2Line } from 'react-icons/ri';

import { useGetCanTextAll } from 'legacy/user/hooks';

import { EventForHost } from 'legacy/events/types';
import Button, { ButtonType } from 'legacy/common/components/button/Button';
import CenteredContainer from 'components/CenteredContainer';
import ScreenBottomBar from 'legacy/components/ScreenBottomBar';

import TextAllGuestsModal from '../guest-list/TextAllGuestsModal';

type HostActionsProps = {
  event: EventForHost;
  onClickViewQrScanner: () => void;
  onClickViewShareOptions: () => void;
  onClickManageEvent: () => void;
  canShare?: boolean;
};

const HostActions: React.FC<HostActionsProps> = ({
  event,
  onClickViewQrScanner,
  onClickViewShareOptions,
  onClickManageEvent,
  canShare
}) => {
  const { push } = useRouter();
  const { data: textAllSettings } = useGetCanTextAll();
  const [showTextAllGuests, setShowTextAllGuests] = useState<boolean>(false);
  const canTextAllGuests = textAllSettings?.canTextAll && event.isOrganizer;
  const canScanTickets = event.isOrganizer || event.isScanner;
  const canAccessManageGuestsModal = event.isOrganizer || event.isPhotographer;

  const toggleTextAllGuests = () => {
    setShowTextAllGuests((prevState) => !prevState);
  };

  const goToEventDashboard = () => {
    push(`/events/${event._id}/dashboard`);
  };

  return (
    <ScreenBottomBar
      aboveContent={
        event.isOrganizer && (
          <CenteredContainer>
            <div className="flex justify-end pb-2">
              <Button
                rounded
                type={ButtonType.Primary}
                onClick={goToEventDashboard}
              >
                <img src="/img/icons/chart-bar-line.svg" />
              </Button>
            </div>
          </CenteredContainer>
        )
      }
    >
      {canShare && (
        <Button
          testId="button-share-event"
          type={ButtonType.Inverted}
          onClick={onClickViewShareOptions}
          icon={<MdIosShare size={20} />}
          mobileRounded
        >
          <span className="hidden md:block">Share event</span>
        </Button>
      )}
      {canScanTickets && (
        <Button
          testId="button-scan-ticket"
          type={ButtonType.Inverted}
          icon={<IoMdBarcode size={20} />}
          onClick={onClickViewQrScanner}
          mobileRounded
        >
          <span className="hidden md:block">Scan tickets</span>
        </Button>
      )}
      {canTextAllGuests && (
        <>
          {/* Text All Guests */}
          <TextAllGuestsModal
            eventId={event._id}
            visible={showTextAllGuests}
            onClose={toggleTextAllGuests}
          />

          <Button
            type={ButtonType.Inverted}
            icon={<RiMessage2Line size={20} />}
            mobileRounded
            onClick={toggleTextAllGuests}
          >
            <span className="hidden md:block">Text guests</span>
          </Button>
        </>
      )}
      {canAccessManageGuestsModal && (
        <Button
          testId="button-manage-event"
          type={ButtonType.Inverted}
          icon={<MdSettings size={20} />}
          onClick={onClickManageEvent}
        >
          Manage event
        </Button>
      )}
    </ScreenBottomBar>
  );
};

export default HostActions;
